import { useState } from 'react';
import { IonCheckbox, IonItem, IonLabel, IonList, useIonAlert } from '@ionic/react';
import PhoneInput from 'react-phone-input-2';
import StepLayout from './StepLayout';
import { appStore, userFormStore } from '../../../store/Store';
import { saveNoPwUserInfo } from '../../../firebaseConfig';

const SAVE_ERROR =
    "We couldn't save your details. Please try again, or contact the Parry Sound Fire Department at 705-746-2262.";

const NoPwProfile1 = () => {
    const noPwUserForm = userFormStore.useState((s) => s.noPwUserForm);
    const noPwUserId = appStore.useState((s) => s.noPwUserId);
    const [presentAlert] = useIonAlert();
    // 'idle' | 'saving' | 'done' | 'error'
    const [status, setStatus] = useState('idle');

    const updateFormDoc = (value, field) => {
        userFormStore.update((s) => {
            s.noPwUserForm = { ...s.noPwUserForm, [field]: value };
        });
    };

    const save = async () => {
        setStatus('saving');
        try {
            await saveNoPwUserInfo(noPwUserId, noPwUserForm);
            setStatus('done');
            // Saving signs the user out, which can unmount this page, so the
            // confirmation is an app-level dialog rather than inline text.
            presentAlert({
                header: 'Sign up successful',
                message: 'You can close the window now.',
                buttons: ['OK'],
            });
        } catch (error) {
            setStatus('error');
        }
    };

    return (
        <StepLayout
            title='What is your phone number?'
            primaryLabel={status === 'saving' ? 'Submitting…' : 'Submit'}
            onPrimary={save}
            primaryDisabled={status === 'saving' || status === 'done'}
        >
            <p className='flow-step__muted'>
                Optional. If left empty, you'll only receive email notifications.
            </p>
            <label className='flow-field-label' htmlFor='signup-phone'>
                Phone number
            </label>
            <PhoneInput
                country='ca'
                value={noPwUserForm.phone}
                onChange={(value) => updateFormDoc(value, 'phone')}
                inputProps={{
                    id: 'signup-phone',
                    name: 'phone',
                    autoComplete: 'tel',
                    'aria-describedby': 'signup-phone-use',
                }}
            />
            <h3 className='flow-step__section-title' id='signup-phone-use'>
                How will we use your phone number?
            </h3>
            <p>
                Communications will come from Parry Sound Fire and Rescue Department and will be
                restricted to notifications of burn bans and other important notices. Your phone
                number will not be used for promotional or marketing purposes or shared with third
                parties.
            </p>
            <IonList lines='full'>
                <IonItem>
                    <IonCheckbox
                        slot='start'
                        color='tertiary'
                        checked={noPwUserForm.emergencySub}
                        onIonChange={(e) => updateFormDoc(e.detail.checked, 'emergencySub')}
                    />
                    <IonLabel className='ion-text-wrap'>
                        Check to receive notifications from Parry Sound Fire Department
                    </IonLabel>
                </IonItem>
            </IonList>
            {status === 'error' && (
                <p className='flow-step__error' role='alert'>
                    {SAVE_ERROR}
                </p>
            )}
        </StepLayout>
    );
};

export default NoPwProfile1;
